import { AppRoute } from '../enums/enums';

const appLinkToReadableMap = {
  [AppRoute.HEALING_NAVIGATOR]: 'Healing Navigator',
  [AppRoute.FIND_A_PROFESSIONAL]: 'Find a Healthcare Professional',
  [AppRoute.LEARN_ABOUT_YOUR_WOUND]: 'Learn About Your Wound',
  [AppRoute.RESOURCES_SUPPORT]: 'Resources & Support',
  [AppRoute.HCP]: 'For Healthcare Professionals',
} as const;

export { appLinkToReadableMap };
